<div class="vflex-300">
  <h2>Time Pickers</h2>
  <div class="surface-muted border-radius-200 pad-200">
    <code>
      import &#123; TimePickerComponent &#125; from '&#64;spaces-ui/meadow/components/date-time';
    </code>
  </div>

  <h3>Time Picker (Button trigger style)</h3>
  <ng-template #timePicker data-sample="timePicker">
    <section class="vflex-300 flex-no-stretch">
      <div class="hflex-100">
        <mdw-time-picker [value]="value()" (valueChange)="value.set($event)"></mdw-time-picker>
      </div>

      <div>
        <p class="bold">Time Value:</p>
        <p class="secondary">{{ timeValue() }}</p>
      </div>
    </section>
  </ng-template>
  <app-sample [sampleContent]="timePicker" sampleName="timePicker"></app-sample>

  <hr />

  <h3>Time Picker (Input trigger style)</h3>
  <ng-template #timePickerInput data-sample="timePickerInput">
    <section class="vflex-300 flex-no-stretch">
      <div class="hflex-100">
        <mdw-time-picker
          triggerType="input"
          [value]="value()"
          (valueChange)="value.set($event)"
        ></mdw-time-picker>
      </div>

      <div>
        <p class="bold">Time Value:</p>
        <p class="secondary">{{ timeValue() }}</p>
      </div>
    </section>
  </ng-template>
  <app-sample [sampleContent]="timePickerInput" sampleName="timePickerInput"></app-sample>

  <hr />

  <h3>Time Input (small)</h3>
  <ng-template #timeInputSmall data-sample="timeInputSmall">
    <section class="vflex-300 flex-no-stretch">
      <mdw-time-input
        size="small"
        [value]="value()"
        (valueChange)="value.set($event)"
      ></mdw-time-input>

      <div>
        <p class="bold">Time Value:</p>
        <p class="secondary">{{ timeValue() }}</p>
      </div>
    </section>
  </ng-template>
  <app-sample [sampleContent]="timeInputSmall" sampleName="timeInputSmall"></app-sample>
</div>
